<template>
  <v-dialog v-model="dialog" persistent max-width="680" :fullscreen="paraMesero && $store.getters.mobile">
    <ValidationObserver v-slot="{ invalid }" ref="form" :tag="paraMesero ? 'div' : 'span'">
      <v-card v-if="config" :key="key" :class="{ 'modal-cliente': true, 'modal-cliente--full': paraMesero && $store.getters.mobile }">
        <div class="cliente__encabezado">
          <v-icon color="white" class="mr-2">mdi-account-outline</v-icon>
          <span class="cliente__titulo">{{ $t("customer") }}</span>
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="cancel" :title="$t('Cancel')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text :class="{ 'cuerpo-cliente': paraMesero }">
          <v-row class="px-2 py-4 mb-3 pb-0">
            <v-col
              cols="12"
              class="py-2 d-flex flex-column align-center justify-center"
            >
              <v-btn-toggle v-model="searchType" mandatory color="primary" class="toggle-cliente">
                <v-btn value="identification">
                  <v-icon left small>mdi-card-account-details</v-icon>Documento
                </v-btn>
                <v-btn value="phone">
                  <v-icon left small>mdi-card-account-phone</v-icon>Celular
                </v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col
              cols="12"
              lg="9"
              class="pb-0"
              v-if="searchType == 'identification'"
            >
              <ng-number-keyboard
                :filled="false"
                :dense="true"
                v-model="identification"
                :label="$t('identification')"
                @keyup.enter="searchClient"
                @clear="clearSearch"
                hide-details
              ></ng-number-keyboard>
            </v-col>
            <v-col
              cols="12"
              lg="3"
              class="mt-0"
              v-if="searchType == 'identification'"
            >
              <v-btn
                block
                color="primary"
                :disabled="!identification"
                @click="searchClient"
                :title="$t('Search')"
              >
                <v-icon>mdi-magnify</v-icon> {{ $t("Search") }}
              </v-btn>
            </v-col>

            <v-col cols="12" lg="9" class="pb-0" v-if="searchType == 'phone'">
              <ng-number-keyboard
                :filled="false"
                :dense="true"
                v-model="phone"
                :label="$t('phone')"
                @keyup.enter="searchClient"
                @clear="clearSearch"
                hide-details
              ></ng-number-keyboard>
            </v-col>
            <v-col cols="12" lg="3" class="mt-0" v-if="searchType == 'phone'">
              <v-btn
                block
                color="primary"
                :disabled="!phone"
                @click="searchClient"
                :title="$t('Search')"
              >
                <v-icon>mdi-magnify</v-icon> {{ $t("Search") }}
              </v-btn>
            </v-col>
          </v-row>
          <v-divider />
          <v-row v-if="searched && item.id && !editando" class="pa-2 my-0 mt-3 pb-0">
            <v-col cols="12" class="pb-0 caption grey--text text--darken-1">Cliente encontrado</v-col>
            <v-col cols="12">
              <div class="tarjeta-cliente">
                <div class="tarjeta-cliente__nombre">{{ item.first_name || item.name }} {{ item.last_name }}</div>
                <div class="tarjeta-cliente__dato">
                  <v-icon small>mdi-card-account-details-outline</v-icon>
                  {{ item.type_identification && item.type_identification.name }} {{ item.identification }}
                </div>
                <div class="tarjeta-cliente__dato" v-if="item.phone">
                  <v-icon small>mdi-phone-outline</v-icon> {{ item.phone }}
                </div>
                <div class="tarjeta-cliente__dato" v-if="item.address">
                  <v-icon small>mdi-map-marker-outline</v-icon> {{ item.address }}
                </div>
              </div>
              <v-btn text small color="primary" class="mt-1" @click="editando = true">
                <v-icon left small>mdi-pencil-outline</v-icon>Editar datos
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="searched && !(item.id && !editando)" class="pa-2 my-0 mt-3 pb-0">
            <!-- {{item}} -->
            <v-col cols="12" class="py-0 pb-2 caption grey--text text--darken-1">
              {{ item.id ? "Editando los datos del cliente" : "No existe: completa sus datos para crearlo" }}
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <ng-text-keyboard
                :filled="false"
                :dense="true"
                v-model="item.first_name"
                :label="$t('first_name')"
                :rules="{ required: true }"
              ></ng-text-keyboard>
            </v-col>
            <v-col cols="12" sm="6" class="py-0" v-if="requireLastName()">
              <ng-text-keyboard
                :filled="false"
                :dense="true"
                v-model="item.last_name"
                :label="$t('last_name')"
                :rules="{ required: !!isInvoiceElectronically() }"
              ></ng-text-keyboard>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <ng-select
                v-model="item.type_identification"
                label="type_identification"
                rules="required"
                url="api/v1/list/type-identification"
              ></ng-select>
            </v-col>
            <v-col cols="12" sm="6" class="py-0" v-if="!(paraMesero && searchType == 'identification')">
              <ng-text
                v-model="item.identification"
                label="identification"
                rules="required"
              ></ng-text>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="py-0"
              v-if="requireVerificationDigit()"
            >
              <ng-integer
                v-model="item.verification_digit"
                label="verification_digit"
                style="width: 49%"
              ></ng-integer>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <ng-phone-keyboard
                :filled="false"
                :dense="true"
                v-model="item.phone"
                :label="$t('phone')"
                :rules="{ required: contactoObligatorio() }"
              ></ng-phone-keyboard>
            </v-col>
            <v-col cols="12" class="py-0 pb-2" v-if="paraMesero && !masDatos">
              <v-btn text small color="primary" @click="masDatos = true">
                <v-icon left small>mdi-plus</v-icon>Más datos (dirección, correo)
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" class="py-0" v-if="!paraMesero || masDatos">
              <ng-text-keyboard
                :filled="false"
                :dense="true"
                v-model="item.address"
                :label="$t('address')"
                :rules="{ required: contactoObligatorio() && (!paraMesero || esDomicilio()) }"
              ></ng-text-keyboard>
            </v-col>
            <v-col cols="12" sm="6" class="py-0"
            v-if="isInvoiceElectronically() && (!paraMesero || masDatos)"
            >
              <ng-email-keyboard
                :filled="false"
                :dense="true"
                v-model="item.email"
                :label="$t('email')"
              ></ng-email-keyboard>
            </v-col>

            <v-col cols="12" sm="6" class="py-0"
            v-if="isInvoiceElectronically() && !paraMesero"
            >
              <ng-select
                v-model="item.country"
                label="country"
                rules="required"
                @change="$refs.region.reload()"
                url="api/v1/list/country"
              ></ng-select>
            </v-col>
            <v-col cols="12" sm="6" class="py-0"
            v-if="isInvoiceElectronically() && !paraMesero"
            >
              <ng-select
                v-model="item.region"
                label="region"
                rules="required"
                :not-auto-load="true"
                :depends-of="{ country: item.country }"
                :cache-off="true"
                ref="region"
                @change="$refs.city.reload()"
                url="api/v1/list/region"
              ></ng-select>
            </v-col>
            <v-col cols="12" sm="6" class="py-0"
            v-if="isInvoiceElectronically() && !paraMesero"
            >
              <ng-select
                v-model="item.city"
                label="city"
                rules="required"
                :not-auto-load="true"
                :depends-of="{ region: item.region }"
                :cache-off="true"
                ref="city"
                url="api/v1/list/city"
              ></ng-select>
            </v-col>

            <v-col cols="12" sm="6" class="py-0"
            v-if="isInvoiceElectronically() && !paraMesero"
            >
              <ng-select
                v-model="item.type_organization"
                label="type_organization"
                rules="required"
                url="api/v1/list/type-organization"
              ></ng-select>
            </v-col>
            <v-col cols="12" sm="6" class="py-0"
            v-if="isInvoiceElectronically() && !paraMesero"
            >
              <ng-select
                v-model="item.type_regimes"
                label="type_regimes"
                rules="required"
                url="api/v1/list/type-regimes"
              ></ng-select>
            </v-col>
          </v-row>
          <v-alert v-if="faltantes.length" type="warning" dense text class="mx-2 mt-3 mb-0">
            Falta completar: {{ faltantes.join(", ") }}.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions v-if="paraMesero" class="pie-cliente">
          <v-btn text large @click="cancel">{{ $t("Cancel") }}</v-btn>
          <v-btn v-if="searched" large depressed color="primary" class="pie-cliente__elegir" @click="elegir">
            {{ $t("select_customer") }}
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn
            dark
            color="grey"
            outlined
            @click="cancel"
            :title="$t('Cancel')"
          >
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn
            v-if="searched"
            color="primary"
            @click="elegir"
            :title="$t('select_customer')"
          >
            {{ $t("select_customer") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>
<script>
const DEFAULT_ITEM = {
  id: "",
  name: "",
  last_name: "",
  email: "",
  identification: "",
  phone: "",
  address: "",
  country: null,
  region: null,
  city: null,
  type_identification: null,
  identification: null,
  verification_digit: null,
  type_organization: null,
  type_regimes: null,
};
export default {
  components: {},
  name: "CartCustomer",
  data: () => ({
    searched: false,
    editando: false,
    masDatos: false,
    faltantes: [],
    tipoPorDefecto: null,
    key: 0,
    searchType: "identification",
    item: JSON.parse(JSON.stringify(DEFAULT_ITEM)),
    config: {
      first_name: {
        name: "first_name",
        label: "Nombres",
        required: true,
        validate: ["required"],
      },
      last_name: {
        name: "last_name",
        label: "Apellidos",
        required: true,
        validate: ["required"],
      },
      identification: {
        name: "identification",
        label: "Numero Identificación",
        required: false,
        validate: [],
      },
      email: { name: "email", label: "Email", required: false, validate: [] },
      phone: {
        name: "phone",
        label: "Celular",
        required: true,
        validate: ["required"],
      },
      address: {
        name: "address",
        label: "Dirección",
        required: false,
        validate: [],
      },
    },
    order: null,
    phone: "",
    identification: "",
  }),
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    // App de meseros: pantalla completa en el celular, búsqueda rotulada y menos datos obligatorios.
    paraMesero: {
      type: Boolean,
      default: false,
    },
  },
  //props: ['customer'],
  watch: {
    // Cliente nuevo: el tipo de documento sale ya puesto (cédula), así solo se escribe el nombre.
    searched(val) {
      if (val) {
        this.ponerTipoPorDefecto();
      }
    },
    dialog(newVal, oldVal) {
      //this.setDefaultClient();
      this.setDefaultClient();
    }
  },
  mounted() {
    this.setDefaultClient();
    /*if(this.customer){
      setTimeout(() => {


      this.item = JSON.parse(JSON.stringify(this.customer));
      this.searched = true;
      this.key++;
      }, 250)
    }*/
  },
  methods: {
    async ponerTipoPorDefecto() {
      if (!this.item || this.item.id || this.item.type_identification) {
        return;
      }
      try {
        if (!this.tipoPorDefecto) {
          const r = await this.$http.get("api/v1/list/type-identification", {}, true, false);
          const lista = (r && r.items) || [];
          this.tipoPorDefecto =
            lista.find((t) => /c[eé]dula de ciudadan/i.test(t.name || "")) || null;
        }
        if (this.tipoPorDefecto && !this.item.id && !this.item.type_identification) {
          this.$set(this.item, "type_identification", this.tipoPorDefecto);
        }
      } catch (e) {
        // sin la lista el cajero lo elige a mano, como antes
      }
    },
    requireLastName() {
      return (
        this.item &&
        this.item.type_identification &&
        this.item.type_identification.requires_last_name
      );
    },
    requireVerificationDigit() {
      return (
        this.item &&
        this.item.type_identification &&
        !this.item.type_identification.requires_last_name
      );
    },
    // Valida al pulsar: si falta algo, marca los campos y dice cuáles son (el botón no se apaga sin explicar).
    async elegir() {
      const ok = await this.$refs.form.validate();
      if (ok) {
        this.faltantes = [];
        this.selected();
        return;
      }
      this.editando = true;
      this.$nextTick(() => {
        const errores = this.$refs.form.errors || {};
        this.faltantes = Object.keys(errores)
          .filter((k) => errores[k] && errores[k].length)
          .map((k) => (this.$te(k) ? this.$t(k) : k));
        const campo = this.$el.querySelector(".error--text");
        if (campo && campo.scrollIntoView) {
          campo.scrollIntoView({ block: "center" });
        }
      });
    },
    selected() {
      this.faltantes = [];
      const obj = JSON.parse(JSON.stringify(this.item));
      if (obj.email == null) {
        obj.email = "";
      }
      this.clear();
      this.clearSearch();
      this.searched = false;
      this.$emit("selected", obj);
      this.key++;
    },
    cancel() {
      this.clear();
      this.clearSearch();
      this.searched = false;
      if (this.$pos.getCurrentOrder().getBusPersonCustomerId() == null) {
        //this.searched = false;
      }
      this.key++;
      this.$emit("cancel");
    },
    clear() {
      this.item = JSON.parse(JSON.stringify(DEFAULT_ITEM));
    },
    searchClient() {
      this.editando = false;
      this.masDatos = false;
      if (this.identification || this.phone) {
        if (this.identification != "" && this.searchType == "identification") {
          let doc = this.identification;
          this.$http
            .get(
              "api/v1/list/client-by-document",
              { name: this.identification },
              true,
              false
            )
            .then((response) => {
              if (response.success) {
                if (response.items && response.items.length > 0) {
                  this.item = response.items[0];
                } else {
                  this.item = { identification: doc };
                }
              }
              this.searched = true;
            })
            .catch((e) => {
              this.searched = true;
            });
        }
        if (this.phone != "" && this.searchType == "phone") {
          let phone = this.phone;
          this.$http
            .get(
              "api/v1/list/client-by-phone",
              { name: this.phone },
              //{ name: this.item.identification },
              true,
              false
            )
            .then((response) => {
              if (response.success) {
                if (response.items && response.items.length > 0) {
                  this.item = response.items[0];
                } else {
                  this.item = { phone: phone };
                }
              }
              this.searched = true;
            })
            .catch((e) => {
              this.searched = true;
            });
        }
      } else {
        this.item = { identification: "" };
        this.phone = "";
        this.searched = false;
      }
    },
    // Sin factura electrónica, y fuera de un domicilio, solo hacen falta el nombre y el documento:
    // el celular y la dirección se piden cuando hacen falta de verdad.
    esDomicilio() {
      const o = this.$pos && this.$pos.getCurrentOrder();
      return !!(o && o.is_domicile);
    },
    contactoObligatorio() {
      return !!this.isInvoiceElectronically() || this.esDomicilio();
    },
    isInvoiceElectronically() {
      return this.$store.getters.getGeneralValue(
        "gen_billing_invoice_electronically"
      );
    },
    clearSearch() {
      this.editando = false;
      this.masDatos = false;
      this.item = {};
      this.phone = "";
      this.identification = "";
      this.searched = false;
    },
    setDefaultClient() {
      if (this.$pos.getCurrentOrder().getBusPersonCustomerId()) {
        this.searched = true;
        this.item = this.$pos.getCurrentOrder().getDataCustomer();
      } else {
        this.searched = false;
        this.item = JSON.parse(JSON.stringify(DEFAULT_ITEM));
      }
    },
  },
};
</script>

<style>
.modal-cliente--full {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
}

.modal-cliente--full .cuerpo-cliente {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.modal-cliente--full > .cliente__encabezado,
.modal-cliente--full > .pie-cliente {
  flex: 0 0 auto;
}

.tarjeta-cliente {
  padding: 12px 14px;
  border: 2px solid #4caf50;
  border-radius: 12px;
  background: #fff;
}

.tarjeta-cliente__nombre {
  font-size: 1.1rem;
  font-weight: 800;
  margin-bottom: 4px;
}

.tarjeta-cliente__dato {
  color: rgba(0, 0, 0, 0.7);
  font-size: 0.95rem;
}

.modal-cliente .toggle-cliente {
  width: 100%;
}

.modal-cliente .toggle-cliente .v-btn {
  flex: 1 1 0;
  min-height: 44px;
}

.pie-cliente {
  position: sticky;
  bottom: 0;
  z-index: 2;
  gap: 8px;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom)) !important;
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.pie-cliente__elegir {
  flex: 1 1 0;
  min-width: 0 !important;
  min-height: 48px !important;
  font-weight: 800;
  color: #fff !important;
}
.cliente__encabezado {
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 8px 0 16px;
  color: #fff;
  background: var(--pos-encabezado);
}

.cliente__titulo {
  font-size: 1.2rem;
  font-weight: 500;
}

.modal-cliente .toggle-cliente {
  margin-bottom: 4px;
}
</style>
